// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QHbH","colBig":"styles_colBig__10pQi","colSmall":"styles_colSmall__2qmSp"};